import React from 'react'
import {
  Container,
  Menu,
  Dropdown,
} from 'semantic-ui-react'

const CompareFooter = ({comparisonMode, selections, comparisonSelectionNames, onPickComparisonSelections, onPickComparisonMode}) => {
  const options = selections.map(s=>{return {key: s.id, text: s.id, value: s.id}});
  const modeOptions = [
    {key: 'overallBarsPercent', text: 'Overall Bars (%)', value: 'overallBarsPercent'},
    {key: 'juxtaposeBarsPercent', text: 'Juxtapose Bars (%)', value: 'juxtaposeBarsPercent'},
    {key: 'overallBarsCount', text: 'Overall Bars (#)', value: 'overallBarsCount'},
    {key: 'overallCounts', text: 'Overall Counts', value: 'overallCounts'},
    {key: 'juxtaposeBarsCount', text: 'Juxtapose Bars (#)', value: 'juxtaposeBarsCount'},
    {key: 'juxtaposeCounts', text: 'Juxtapose Counts', value: 'juxtaposeCounts'},
  ]
  //console.log(options);
  return (
    <Menu fixed='bottom' color='yellow' inverted>
      <Container>
        <Menu.Item header>Compare</Menu.Item>
        <Menu.Item>
          <Dropdown
            selection
            placeholder='Pick mode'
            options={modeOptions}
            value={comparisonMode}
            onChange={(e, {value}) => onPickComparisonMode(value)}
          />
        </Menu.Item>
        <Menu.Item>
          <Dropdown
            fluid
            multiple
            selection
            placeholder='Choose selections'
            options={options}
            value={comparisonSelectionNames}
            renderLabel={(label)=>({color: 'orange', content: label.text})}
            onChange={(e, {value}) => onPickComparisonSelections(value)}
          />
        </Menu.Item>
      </Container>
    </Menu>
  );
}

export default CompareFooter